import {
  ActionReducerMapBuilder,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { searchBlogs } from './search.actions';

const initialState: SearchResultsType = {
  paginator: {
    count: 0,
    page: 1,
    page_size: 20,
    total_pages: 0,
    next: null,
    previous: null,
  },
  blogs: [],
  results: [], // New
  count: 0, // New
  isSearchLoading: false,
  searchErrorMessage: '',
  searchQuery: '',
  lastSearchTime: 0,
};

const searchSlice = createSlice({
  name: 'profileStateSlice',
  initialState,
  reducers: {
    setSearchQuery: (
      state: SearchResultsType,
      action: PayloadAction<string>
    ) => {
      state.searchQuery = action.payload;
    },
    triggerSearch: (
      state: SearchResultsType,
      action: PayloadAction<string>
    ) => {
      state.searchQuery = action.payload;
      state.lastSearchTime = Date.now();
    },
    clearSearchResults: (state: SearchResultsType) => {
      state.blogs = [];
      state.results = [];
      state.count = 0;
      state.paginator = {
        count: 0,
        page: 1,
        page_size: 20,
        total_pages: 0,
        next: null,
        previous: null,
      };
    },
  },
  extraReducers: builder => {
    searchBlogsCases(builder);
  },
});

const searchBlogsCases = (
  builder: ActionReducerMapBuilder<SearchResultsType>
) => {
  builder.addCase(searchBlogs.pending, (state: SearchResultsType) => {
    state.isSearchLoading = true;
    state.searchErrorMessage = '';
  });
  builder.addCase(searchBlogs.fulfilled, (state, action) => {
    // New API response format: { count: number, results: UnifiedSearchResultType[] }
    const payload: SearchAPIResponse = action.payload;

    // Store unified results
    state.results = payload.results || [];
    state.count = payload.count || 0;
    // Update paginator with new pagination data
    state.paginator = {
      count: payload.count || 0,
      page: payload.page || 1,
      page_size: payload.page_size || 20,
      total_pages: payload.total_pages || 0,
      next: payload.next || null,
      previous: payload.previous || null,
    };


    state.isSearchLoading = false;
  });
  builder.addCase(searchBlogs.rejected, (state, action) => {
    state.searchErrorMessage =
      action.error.message || 'Failed to fetch results';
    state.isSearchLoading = false;
  });

  return builder;
};

export const { setSearchQuery, triggerSearch, clearSearchResults } = searchSlice.actions;

export default searchSlice.reducer;
